module.exports = __webpack_public_path__ + "img/introductors.e8d7bfad.png";